import { render } from "./ZModalForm.vue?vue&type=template&id=5ddfa99b"
import script from "./ZModalForm.vue?vue&type=script&lang=js"
export * from "./ZModalForm.vue?vue&type=script&lang=js"

import "./ZModalForm.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script